<template>
  <div>
    <div :style="promotionStyle" class="rounded-t-md px-3.5 py-3">
      <div class="flex items-center gap-1">
        <span class="flex h-[1.125rem] w-auto items-center justify-center">
          <LazyIconFielmannLock class="size-3 text-white" />
        </span>
        <Headline tag="h2" size="sm" class="text-white" weight="medium">
          {{ promotionGiftsHeadline }}
        </Headline>
      </div>

      <p class="text-2xs mt-1 text-white">
        {{ promotionGiftsDescription }}
      </p>
    </div>
    <div class="rounded-b-md border border-gray-350 bg-white pt-4">
      <div class="max-h-72 overflow-y-scroll px-3.5" @scroll="onScroll">
        <ProductPromotionGiftItem
          v-for="(item, index) in products"
          :key="item.id"
          v-bind="{ promotionStyle, isProductAddedToBasket }"
          :eager-image-loading="index < 2"
          :product="item"
          class="mb-4 last-of-type:mb-0"
        />
      </div>
      <div
        class="relative z-20 mt-4 px-4 py-2 text-center"
        :class="shadowClass"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Product } from '@scayle/storefront-nuxt'
const i18n = useI18n()
const props = defineProps<{ product: Product }>()

const { isProductAddedToBasket, areGiftConditionsMet } =
  await useProductPromotions(props.product)

const { promotionStyle, products, hasMultipleFreeGifts } =
  await usePromotionGifts(props.product)

const hasScrolledToBottom = ref(false)

const onScroll = (element: any) => {
  hasScrolledToBottom.value = isScrolledToBottom(element)
}

const promotionGiftsHeadline = computed(() => {
  return areGiftConditionsMet.value
    ? i18n.t('pdp.promotion.free_gift_conditions_met.headline')
    : i18n.t('pdp.promotion.free_gift_conditions_not_met.headline')
})

const promotionGiftsDescription = computed(() => {
  return areGiftConditionsMet.value
    ? i18n.t('pdp.promotion.free_gift_conditions_met.description')
    : i18n.t('pdp.promotion.free_gift_conditions_not_met.description')
})

const shadowClass = computed(() => {
  return (
    hasMultipleFreeGifts.value &&
    !hasScrolledToBottom.value &&
    'top-white-shadow'
  )
})
</script>
